/** @format */

import { post } from '@root/utils/httpWrap';

// 车场概况
export const queryParkingOverviewData = (params: any): any => {
  return post('/bangdao/saasapi/v1/business/groupParkReport', params);
};

export const querySingleParkingOverviewData = (params: any): any => {
  return post('/bangdao/saasapi/v1/business/parkReport', params);
};
// 收费概况
export const queryIncomeOverviewData = (params: any): any => {
  return post('/bangdao/saasapi/v1/business/groupChargeList', params);
};

// 今日流量table
export const queryGroupTodayDischargeList = (params: any): any => {
  return post('/bangdao/saasapi/v1/business/groupTodayFlowCount', params);
};
export const queryParkTodayDischargeList = (params: any): any => {
  return post('/bangdao/saasapi/v1/business/parkTodayFlowCount', params);
};
// 今日流量chart
export const queryTodayDischargeChart = (params: any): any => {
  return post('/bangdao/saasapi/v1/businessOverview/todayDischarge/chart', params);
};

// 收入趋势
export const queryIncomeStatistics = (params: any): any => {
  return post('/bangdao/saasapi/v1/business/groupChargeTrendList', params);
};

// 收入趋势
export const queryIncomeStatisticsRank = (params: any): any => {
  return post('/bangdao/saasapi/v1/businessOverview/incomeStatisticsRank', params);
};

// 异常统计
export const queryAbnormalStatistics = (params: any): any => {
  return post('/bangdao/saasapi/v1/business/groupExceptionList', params);
};

// 支付渠道统计
export const queryPaymentStatistics = (params: any): any => {
  return post('/bangdao/saasapi/v1/business/groupChargeChannelRate', params);
};

// 车位数量
export const queryParkingCount = (params: any): any => {
  return post('/bangdao/saasapi/v1/businessOverview/parkingCount', params);
};

// 车位数量
export const queryDeviceCount = (params: any): any => {
  return post('/bangdao/saasapi/v1/businessOverview/deviceCount', params);
};
